import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { ErrorOutline as ErrorIcon } from "@mui/icons-material";
import { useState } from "react";
import { useDevice } from "../../../../providers/DeviceProvider";
import { useAuth } from "@emberly/zenith-client";
import axios from "axios";
import { GetUserReference } from "../../../../common/orders";

const useStyles = makeStyles()(
  (theme) => ({
    checkCircle: {
      width: "108px",
      height: "108px",
      color: theme.palette.success.main
    },
    button: {
      "@media (max-width: 500px)": {
        padding: theme.spacing(3.5)
      }
    },
    isMobilePortraitView: {
      "& .MuiDialogContent-root": {
        padding: theme.spacing(1.5),
      },
      "& h2.MuiTypography-root.MuiDialogTitle-root": {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5)
      },
      "& .MuiDialogActions-root": {
        padding: theme.spacing(1.5),
        paddingBottom: theme.spacing(0),
        flexDirection: "column-reverse",
        "& > button": {
          width: "100%",
          margin: 0,
          marginBottom: theme.spacing(1),
          padding: theme.spacing(1),
          flex: 1,
        }
      }
    }
  })
);

export default function MissionRequestResponseDialog(props) {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { accept, reject, requestId, action } = props;
  const { isMobilePortraitView } = useDevice();
  const { getAccessTokenSilently, user } = useAuth();

  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [working, setWorking] = useState(false);

  const submitResponse = async (acceptance, openMission) => {
    try {
      setWorking(true);
      let body = {
        requestId,
        accepted: acceptance,
        message,
        responder: GetUserReference(user)
      }

      const res = await axios.post("/api/missionrequest/respond",
        body,
        {
          headers: { Authorization: `Bearer ${await getAccessTokenSilently()}` },
        }
      );

      let data = res.data;

      if (data.missionId && openMission) {
        action.complete({ ...data, openMission: true });
      } else {
        action.complete(data);
      }

    } catch (err) {
      console.log(err);
      setError(true);
    } finally {
      setWorking(false);
    }
  };


  return (
    <Dialog
      open
      maxWidth="sm"
      fullWidth
      onClose={() => action.throw("cancelled")}
      className={`${isMobilePortraitView ? classes.isMobilePortraitView : ""}`}
    >
      <DialogTitle>
        {accept ? t("missionRequests:acceptDialog:title") : t("missionRequests:rejectDialog:title")}
      </DialogTitle>

      <DialogContent>
        <Stack alignItems="center" spacing={1}>
          {reject ? <Typography variant="body1">{t("missionRequests:rejectDialog:description")}</Typography> : null}

          <TextField
            label={accept ? t("missionRequests:acceptDialog:message") : t("missionRequests:rejectDialog:message")}
            onChange={ev => setMessage(ev.target.value)}
            value={message}
            variant="filled"
            fullWidth
            multiline
            minRows={2}
            size="small"
          />

          {
            error ? (
              <Typography variant="body1" color="error" textAlign="left" sx={{ width: "100%" }}>
                <ErrorIcon fontSize="inherit" sx={{ marginBottom: -0.25, marginRight: 0.5 }} />
                {accept ? t("missionRequests:acceptDialog:error") : t("missionRequests:rejectDialog:error")}
              </Typography>
            ) : null
          }

        </Stack>
      </DialogContent>
      {
        accept ? (
          <DialogActions>
            <Button onClick={() => action.throw("cancelled")}>
              {t("common:cancel")}
            </Button>

            <Button variant="outlined" onClick={() => submitResponse(true, false)} disabled={working}>
              {t("missionRequests:acceptDialog:accept")}
            </Button>

            <Button variant="contained" onClick={() => submitResponse(true, true)} loading={working} disabled={working}>
              {t("missionRequests:acceptDialog:acceptAndOpen")}
            </Button>
          </DialogActions>
        ) : (
          <DialogActions>
            <Button onClick={() => action.throw("cancelled")}>
              {t("common:cancel")}
            </Button>

            <Button variant="contained" color="error" onClick={() => submitResponse(false)} loading={working} disabled={working}>
              {t("missionRequests:rejectDialog:reject")}
            </Button>
          </DialogActions>
        )
      }
    </Dialog >
  );
}